import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import * as getters from './getters';

Vue.use(Vuex);
// 应用初始状态
const state = {
  // resquest:'https://dev.finsen.scrm.essesuit.com',//测试地址
  resquest:"https://api.work.finsen.com.cn",//正式地址

  // dingdingurl:'http://0.0.0.0:8081/#/dingdinglogin',//本地
  // dingdingurl:'https://dev.work.finsen.com.cn/#/dingdinglogin',//测试
  dingdingurl:'https://work.finsen.com.cn/#/dingdinglogin',//正式

  userInfo: JSON.parse(localStorage.getItem('user_info')) || '',
  token:localStorage.getItem('token') || '',
  rightList:JSON.parse(localStorage.getItem('rightList')) || [],
  userWorkInfo:{},
  passwordLogin:false,
  callStatus:true,//拨打电话按钮
  ringoffBtn:false,//挂断电话按钮
  callLoadingStatus:false,
  customerCall:false,
  iframeUrl:false,
  dateOptions: {
    shortcuts: [{
      text: '今日累计',
      onClick(picker) {
        const end = new Date();
        const start = new Date(new Date().setHours(0, 0, 0, 0));
        picker.$emit("pick", [start, end]);
      },
    },{
      text: '昨天',
      onClick(picker) {
        const end = new Date();
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, end]);
      }
    },{
      text: '过去7天',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '过去30天',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: "本月",
      onClick(picker) {
        let currentDate = new Date();
        let currentMonth = currentDate.getMonth();
        //获得当前年份4位年
        let currentYear = currentDate.getFullYear();
        //求出本月第一天
        const start = new Date(currentYear, currentMonth, 1);
        const end = new Date();
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: '上个月',
      onClick(picker) {
          var now = new Date();
          var year = now.getFullYear();
          var month = now.getMonth();
          if(month==0){
            month = 12;
            year = year-1;
          }
          if(month<10){
            month = '0'+month;
          }
          var myDate = new Date(year,month,0);
          // 上个月第一天
          var startDate = new Date(year+'-'+month+'-01 00:00:00');
          // 上个月最后一天
          var endDate = new Date(year+'-'+month+'-'+myDate.getDate()+' 23:59:59');
          picker.$emit('pick', [startDate, endDate]);
      }
    },{
      text: '所有时间',
      onClick(picker) {
        const end = new Date();
        const start = new Date('2023-3-1');
        picker.$emit('pick', [start, end]);
      }
    }],
    disabledDate(date) {
      return date.getTime() > Date.now(); // 禁用大于今天的日期
    }
  },
  dateTimeOptions: {
    shortcuts: [{
      text: '最近一周',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近一个月',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近三个月',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        picker.$emit('pick', [start, end]);
      }
    }]
  },
  provinceoptions:[
    {id:'北京市',name:'北京市',},
    {id:'上海',name:'上海',},
    {id:'云南省',name:'云南省',},
    {id:'内蒙古自治区',name:'内蒙古自治区',},
    {id:'吉林省',name:'吉林省',},
    {id:'四川',name:'四川',},
    {id:'天津',name:'天津',},
    {id:'宁夏回族自治区',name:'宁夏回族自治区',},
    {id:'安徽省',name:'安徽省',},
    {id:'山东',name:'山东',},
    {id:'山西省',name:'山西省',},
    {id:'广东省',name:'广东省',},
    {id:'广西壮族自治区',name:'广西壮族自治区',},
    {id:'新疆维吾尔自治区',name:'新疆维吾尔自治区',},
    {id:'西藏自治区',name:'新疆维吾尔自治区',},
    {id:'江西省',name:'江西省',},
    {id:'河北省',name:'河北省',},
    {id:'河南省',name:'河南省',},
    {id:'浙江',name:'浙江',},
    {id:'海南省',name:'海南省',},
    {id:'湖北省',name:'湖北省',},
    {id:'湖南省',name:'湖南省',},
    {id:'甘肃省',name:'甘肃省',},
    {id:'福建省',name:'福建省',},
    {id:'贵州省',name:'贵州省',},
    {id:'辽宁',name:'辽宁',},
    {id:'重庆',name:'重庆',},
    {id:'陕西省',name:'陕西省',},
    {id:'青海省',name:'青海省',},
    {id:'黑龙江',name:'黑龙江',},
    {id:'江苏',name:'江苏',},
  ],
  sendoptions:[
    {id:'顺丰快递',name:'顺丰快递',},
    {id:'顺丰到付',name:'顺丰到付',},
    {id:'圆通快递',name:'圆通快递',},
    {id:'韵达快递',name:'韵达快递',},
    {id:'邮政快递',name:'邮政快递',},
    {id:'极兔快递',name:'极兔快递',},
    {id:'中通快递',name:'中通快递',},
    {id:'申通快递',name:'申通快递',},
  ],
  tagsList:[],
  customerId:'',//消息列表跳转到客户列表
  customerSearchType:'',//消息列表跳转到客户列表
  calldialog:false,//打电话添加备注弹框
  calldialogsmall:false,//打电话添加备注弹框收起
  callSubmit:false,//打电话备注弹框提交
  currentSize:'',
};
// 定义所需的 mutations
const mutations = {
  setRightList(state, data) {
    state.rightList = data
    localStorage.setItem('rightList',JSON.stringify(data))
  },
  settagsList(state, data) {
    state.tagsList = data;
  },
  setuserWorkInfo(state, data) {
    state.userWorkInfo = data
  },
  //存储用户信息
  getuserInfo(state, pro) {
    state.userInfo = pro;
  },
  clearUserInfo(state, pro) {
    state.userInfo = {};
  },
  //存住token 信息
  setToken(state,data){
    state.token = data
  },
  clearToken(state,data){
    state.token = null
  },
  //存住passwordLogin 信息
  setpasswordLogin(state,data){
    state.passwordLogin = data
  },
  clearcpasswordLogin(state,data){
    state.passwordLogin = true
  },
  //存住callStatus 信息
  setcallStatus(state,data){
    state.callStatus = data
  },
  clearcallStatus(state,data){
    state.callStatus = true
  },
  //存住ringoffBtn 信息
  setringoffBtn(state,data){
    state.ringoffBtn = data
  },
  clearringoffBtn(state,data){
    state.ringoffBtn = false
  },
  //存住callSubmit 信息
  setcallSubmit(state,data){
    state.callSubmit = data
  },
  clearcallSubmit(state,data){
    state.callSubmit = false
  },
  //存住callLoadingStatus 信息
  setcallLoadingStatus(state,data){
    state.callLoadingStatus = data
  },
  clearcallLoadingStatus(state,data){
    state.callLoadingStatus = false
  },
  //存住customerCall 信息
  setcustomerCall(state,data){
    state.customerCall = data
  },
  clearcustomerCall(state,data){
    state.customerCall = false
  },
  //存住iframeUrl 信息
  setiframeUrl(state,data){
    state.iframeUrl = data
    sessionStorage.setItem('iframeUrl',data)
  },
  cleariframeUrl(state,data){
    state.iframeUrl = false
  },
  //存住customerId 信息
  setcustomerId(state,data){
    state.customerId = data
    sessionStorage.setItem('customerId',data)
  },
  clearcustomerId(state,data){
    state.customerId = true
  },
  //存住customerSearchType 信息
  setcustomerSearchType(state,data){
    state.customerSearchType = data
    sessionStorage.setItem('customerSearchType',data)
  },
  clearcustomerSearchType(state,data){
    state.customerSearchType = true
  },
  setcalldialog(state, data) {
    state.calldialog = data
    localStorage.setItem('calldialog',JSON.stringify(data))
  },
  setcalldialogsmall(state, data) {
    state.calldialogsmall = data
    localStorage.setItem('calldialogsmall',JSON.stringify(data))
  },
  currentSize(state, pro) {
    state.currentSize = Number(JSON.parse(pro));
  },
};

// 创建 store 实例
export default new Vuex.Store({
  actions,
  getters,
  state,
  mutations,
});



// WEBPACK FOOTER //
// ./src/vuex/store.js